import React from 'react'
import CloseIcon from '@material-ui/icons/Close'
import { makeStyles } from '@material-ui/core/styles'
import styles from '../../../../../styles'
import classNames from 'classnames'
import { ClassValue } from 'classnames/types'
import { useMediaQuery } from 'react-responsive'
import { FormattedMessage } from 'react-intl'
import { OnlinePaymentModal } from '../../../../../types/contracts/contractsModel'
import { onlinePaymentMode } from '../../../../../enums/contractsEnum'
import portals from '../../../../../enums/portalsEnum'
import links from '../../../../../enums/linksEnum'
import { useHistory } from 'react-router-dom'

const useStyle = makeStyles(
    (theme) => (
        {
            ...styles(theme),
            headerStyleLargeScreen: {
                '& #logo': {
                    margin: '2vw',
                    width: '100%',
                    maxWidth: 150,
                    cursor: 'pointer'
                }
            },
            headerStyleSmallScreen: {
                width: '100%',
                margin: 0,
                height: '10vw',
                minHeight: 50,

                '& > div:first-child': {
                    display: 'flex',
                    alignItems: 'center',
                    height: '100%',

                    '& #logo': {
                        height: '100%',
                        marginRight: 15
                    }
                }
            },
            iconStyle: {
                background: theme.palette.blue['5'],
                padding: 12,
                borderRadius: '100%',
                color: theme.palette.blue.main,
                cursor: 'pointer'
            },
            subHeaderStyle: {
                width: '80%',
                maxWidth: 1100,
                margin: '54px auto 0',
                '& p': {
                    color: theme.palette.blue.main,
                    margin: 0
                }
            }
        }
    )
)

interface AcceptingProps {
    closeDialog: () => void,
    paymentModal: OnlinePaymentModal
}

type PaymentHeaderProps = AcceptingProps

const PaymentHeader: React.FC<PaymentHeaderProps> = (
    {
        closeDialog,
        paymentModal
    }
) => {

    const classes = useStyle()
    const history = useHistory()
    const isLargeScreen = useMediaQuery(
        {
            query: '(min-width: 1025px)'
        }
    )

    const headerClass: ClassValue = classNames(
        'row middle-xs',
        classes.flexBetween,
        isLargeScreen ? classes.headerStyleLargeScreen : classes.headerStyleSmallScreen
    )

    const titleSmallScreenClass: ClassValue = classNames(
        classes.title5,
        classes.colorBlue
    )
    const subHeaderClass: ClassValue = classNames(
        'row middle-xs',
        classes.subHeaderStyle
    )

    const subtitle = paymentModal.type === onlinePaymentMode.all ? {
        id: 'contracts.account.payment.all.subtitle',
        defaultMessage: 'Paiement de votre solde'
    } : {
        id: 'contracts.account.payment.partial.subtitle',
        defaultMessage: 'Effectuez votre paiement'
    }
    const redirectTo = (link: string) => {
        closeDialog()
        history.push(link)
    }

    return (
        <>
            <div className={headerClass}>
                {
                    isLargeScreen ? (
                        <div className="col-md-2">
                            <img
                                src={process.env.REACT_APP_TARGET === portals.residence ? 'img/youFirst.jpg' : 'img/youFirstCampus.svg'}
                                alt="Logo Youfirst"
                                id="logo"
                                onClick={() => redirectTo(links.dashboard)}
                            />
                        </div>
                    ) : (
                        <div className="col-xs-8">
                            {
                                <span className={titleSmallScreenClass}>
                                    <FormattedMessage
                                        id="contracts.account.payment.title"
                                        defaultMessage="Paiement sécurisé"
                                        description="Modal title"
                                    />
                                </span>
                            }

                        </div>
                    )
                }
                <div className="col-xs-4 col-md-2">
                    <div className="row middle-xs end-xs">
                        <div className="col-xs-12 col-md-4">
                            <CloseIcon
                                onClick={closeDialog}
                                className={classes.iconStyle}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {isLargeScreen &&
			<div className={subHeaderClass}>
				<div className="col-xs-offset-1 col-xs-11">
					<p className={classes.title4}>
						<FormattedMessage
							id="contracts.account.payment.title"
							defaultMessage="Paiement sécurisé"
							description="Modal title"
						/>
					</p>
					<p className={classes.title1}>
						<FormattedMessage
                            {...subtitle}
							description="Modal subtitle"
						/>
					</p>
				</div>
			</div>
            }
        </>
    )
}

export default PaymentHeader
